var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + _vm.size),{tag:"component",class:{'vuw-dynamic-text-color': _vm.dynamicColor}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }